import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Icon, IconName } from '../icons/icon/icon-component';
import styles from './callout-alert-component.module.scss';

type CalloutAlertProps = PropsWithChildren<{
  icon: IconName;
  headline: string;
  colour?: 'yellow' | 'teal' | 'pink' | 'green' | 'purple';
}>;

/**
 * Callout Alert component
 *
 * https://www.figma.com/design/CK8p85NlyAEksui8ZeJ1Xr/ion?node-id=1970-4217&t=gJ9JOUnY7YBrrKtW-4
 */
export const CalloutAlert: FunctionComponent<CalloutAlertProps> = ({ colour = 'yellow', ...props }) => {
  return (
    <div className={`${styles['callout-alert-component']} ${styles[`${colour}`]}  `}>
      <div className={styles.title}>
        {props.icon && <Icon name={props.icon} color='white' className={styles.icon} />}
        <span className={styles.headline}>{props.headline}</span>
      </div>
      <div>{props.children}</div>
    </div>
  );
};

export default CalloutAlert;
